export const environment = {
  production: false,
  sentry: false,
  hmr: false,
  apiUrl: 'https://api.awizor.test.maio.sh/v1/panel'
};
